import React from 'react';

const withFormTemplate = WrappedComponent => {
    const form = ({ formType, 
        formTemplate, 
        isLoading = false, 
        endpoint, 
        endpointForQuickComplete,
        endpointForQuickPay,
        endpointForApprove,
        endpointForNewCopy, 
        isViewOnly, 
        isNoDeactivate,
        showReport,
        reportColumn,
        reportEndpoint,
        dataKeys,
        hasNoDate,
        isModal
    }) => {
        return formTemplate ?
            <WrappedComponent
                isLoading={isLoading}
                endpoint={endpoint}
                endpointForQuickComplete={endpointForQuickComplete}
                endpointForQuickPay={endpointForQuickPay}
                endpointForApprove={endpointForApprove}
                endpointForNewCopy={endpointForNewCopy}
                isViewOnly={isViewOnly}
                isNoDeactivate={isNoDeactivate}
                showReport={showReport}
                reportColumn={reportColumn}
                reportEndpoint={reportEndpoint}
                dataKeys={dataKeys}
                hasNoDate={hasNoDate}
                isModal={isModal}
            /> :
            null
    }

    return form;
};

export default withFormTemplate;